namespace SolovisGateway.Admin.DataEnvironments {

    export class EnvironmentUserRolesDialog {

        private _dataEnvironmentId;
        private _userData;

        private _roles;
        private _rolesDiv;

        constructor(dataEnvironmentId, userData) {
            this._dataEnvironmentId = dataEnvironmentId;
            this._userData = userData;
        }

        public show() {
            let self = this;
            let userData = this._userData;
            
            let dialogDiv = $("<div>");

            let rolesDiv = $("<div>").appendTo(dialogDiv);
            this._rolesDiv = rolesDiv;            

            let dialog = new Solovis.UI.Dialog({
                container: dialogDiv,
                title: "Environment Roles For " + userData.fullName,
                autoOpen: true,
                width: 500,
                height: 300,
                modal: true,
                center: true,
                actions: ["Close"],
                buttons: [
                    { label: "Add Role", click: function () { self._showAddRoleDialog(); } },
                    { label: "Close", click: function () { dialog.close(); } }
                ]
            });

            this._updateRolesList();     
        }

        private _updateRolesList() {
            let self = this;

            Solovis.Rpc.invokeAndWait(
                "~/DataEnvironment/GetUserEnvironmentRoles",
                { dataEnvironmentId: this._dataEnvironmentId, userId: self._userData.id },
                function (response, success) {
                    if (success) {
                        let roles = response.result.roles;
                        self._roles = roles;

                        self._rolesDiv.html("");

                        if (!_.isEmpty(roles)) {
                            for (let role of roles) {
                                let roleDiv = $("<div>").text(role);
                                if (role != 'System Admin' || !self._userData.isEnvironmentAdmin) {
                                    // NOTE: System Admin can only be removed here when the user is not an environment admin.
                                    // Otherwise it must be toggled via the Environment Admin checkbox so the two stay in sync.
                                    let removeLink = $("<a><span class='fa fa-remove' /></a>")
                                        .css("padding-left", "5px")
                                        .appendTo(roleDiv);
                                    removeLink.click(function () {
                                        let confirmDiv = $("<div>").text("Remove role '" + role + "'?");
                                        Solovis.UI.confirm(confirmDiv, "Remove", function (confirmed) {
                                            if (confirmed) {
                                                Solovis.Rpc.invokeAndWait(
                                                    "~/DataEnvironment/ToggleEnvironmentUserRole",
                                                    { dataEnvironmentId: self._dataEnvironmentId, userId: self._userData.id, roleName: role, roleEnabled: false },
                                                    function (response, success) {
                                                        if (success) {
                                                            self._updateRolesList();
                                                        }
                                                    }
                                                );
                                            }
                                        });
                                    });
                                }

                                roleDiv.appendTo(self._rolesDiv);
                            }
                        }
                        else {
                            $("<div>").text("No roles assigned.").appendTo(self._rolesDiv);
                        }
                    }
                }
            );    
        }


        private _showAddRoleDialog() {
            let self = this;

            let currentRoleSet: any = {};
            $(this._roles).each(function (i, roleName: any) {
                currentRoleSet[roleName] = true;
            });

            Solovis.Rpc.invokeAndWait(
                "~/DataEnvironment/GetAvailableEnvironmentRoles",
                { dataEnvironmentId: this._dataEnvironmentId },
                function (response, success) {
                    if (success) {       
                        let availableRoles: string[] = [];
                        $(response.result.roles).each(function (i, roleName: any) {
                            if (!currentRoleSet[roleName]) {
                                availableRoles.push(roleName);
                            }                            
                        });  

                        self._internalShowAddRoleDialog(availableRoles);                       
                    }
                }
            );    
        }

        private _internalShowAddRoleDialog(availableRoles) {
            let self = this;

            let dialogDiv = $("<div>");

            let formBuilder = new Solovis.UI.InputControls.FormBuilder({
                container: dialogDiv
            });

            let roles: any = _.map(availableRoles, function (role) {
                return {
                    text: role,
                    value: role
                };                
            });

            formBuilder.addEntry({
                name: "roles",
                label: "Roles",

                editor: {
                    type: "multiselect",
                    multiselectOptions: {
                        data: roles,
                        searchEnabled: true,
                        showClearButton: true                        
                    }
                }
            })

            let dialog = new Solovis.UI.Dialog({
                container: dialogDiv,
                title: "Add Role For " + this._userData.fullName,
                autoOpen: true,
                width: 600,
                height: 200,
                modal: true,
                center: true,
                actions: ["Close"],
                buttons: [        
                    {
                        label: "Add Role",
                        click: function () {
                            let roleNames = formBuilder.getValueByName("roles");
                            if (roleNames) {
                                Solovis.Rpc.invokeAndWait(
                                    "~/DataEnvironment/ToggleEnvironmentUserRole",
                                    { dataEnvironmentId: self._dataEnvironmentId, userId: self._userData.id, roleNames: roleNames, roleEnabled: true },
                                    function (response, success) {
                                        if (success) {
                                            dialog.close();
                                            self._updateRolesList();
                                        }
                                    }
                                );
                            }
                        }
                    },           
                    { label: "Cancel", click: function () { dialog.close(); } }
                ],

                contentWidthSizer: {
                    setWidth: function (newWidth) {
                        formBuilder.setWidth(newWidth);
                    }
                }
            });
        }
    }

}